const translations = {
    drone: 'Drone',
    faaRegNumber: 'FAA Reg. Number',
    pilots: 'Pilots',
    totalFlightTime: 'Total Flight Time',
    totalFlights: 'Total Flights'
};

export default translations;
